import * as React from 'react';
import { buttonClassNames, makeStyles, tokens, Spinner, ButtonProps, mergeClasses } from '@fluentui/react-components';
import { CheckmarkFilled } from '@fluentui/react-icons';
import { Button } from './Button';

const useStyles = makeStyles({
  buttonNonInteractive: {
    [`& .${buttonClassNames.icon}`]: {
      color: tokens.colorStatusSuccessForeground1,
    },
  },
});

export type LoadingState = 'initial' | 'loading' | 'loaded';

export type LoadingButtonProps = ButtonProps & {
  loadingState: LoadingState;
};

export const LoadingButton = ({ loadingState, className, children, ...rest }: LoadingButtonProps) => {
  const styles = useStyles();

  return (
    <Button
      className={mergeClasses(loadingState !== 'initial' && styles.buttonNonInteractive, className)}
      disabledFocusable={loadingState !== 'initial'}
      icon={loadingState !== 'initial' ? <LoadingIcon state={loadingState} /> : null}
      {...rest}
    >
      {children}
    </Button>
  );
};

const LoadingIcon = ({ state }: { state: LoadingState }) => {
  switch (state) {
    case 'loading':
      return <Spinner size="tiny" />;
    case 'loaded':
      return <CheckmarkFilled />;
    default:
      return null;
  }
};
